import { render, staticRenderFns } from "./SubmitDemoCard.vue?vue&type=template&id=34b1b385&scoped=true"
import script from "./SubmitDemoCard.vue?vue&type=script&lang=js"
export * from "./SubmitDemoCard.vue?vue&type=script&lang=js"
import style0 from "./SubmitDemoCard.vue?vue&type=style&index=0&id=34b1b385&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b1b385",
  null
  
)

export default component.exports